import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type BulkDeleteMaterialVolumetricPricesResponse = ClientInferResponseBody<
  typeof contract.materials.bulkDeleteMaterialVolumetricPrices,
  200
>;

export const bulkDeleteMaterialVolumetricPricesApi = async ({
  ids,
}: {
  ids: string[];
}): Promise<BulkDeleteMaterialVolumetricPricesResponse> => {
  const response = await api.materials.bulkDeleteMaterialVolumetricPrices.mutation({
    body: { ids },
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to bulk delete volumetric materials", response.status, response.body);
};
